import React from "react";
import { RootElement } from "./src/templates/providers";
import { redirectEcCampaignLandingIfNeeded } from "./src/hooks/use-ec-campaign-landing";
import "./global.css";
import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/mulish/400.css";
import "@fontsource/mulish/700.css";

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
  return <RootElement>{element}</RootElement>;
};

export const onRouteUpdate = (): void => {
  redirectEcCampaignLandingIfNeeded();
};
